import { render, staticRenderFns } from "./TrafiklabWidget.vue?vue&type=template&id=7a5c311b&scoped=true"
import script from "./TrafiklabWidget.vue?vue&type=script&lang=js"
export * from "./TrafiklabWidget.vue?vue&type=script&lang=js"
import style0 from "./TrafiklabWidget.vue?vue&type=style&index=0&id=7a5c311b&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a5c311b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/yogeshadhikari/Desktop/Projects/Scopic/picflow/picflow-fe/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7a5c311b')) {
      api.createRecord('7a5c311b', component.options)
    } else {
      api.reload('7a5c311b', component.options)
    }
    module.hot.accept("./TrafiklabWidget.vue?vue&type=template&id=7a5c311b&scoped=true", function () {
      api.rerender('7a5c311b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/templates/viewer/templateWidgets/TrafiklabWidget.vue"
export default component.exports